import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchUnsignedPrivacyPolicy,
  FetchPrivacyPoliciesArgs,
} from '../api/types/privacyPolicies.types';

import {
  fetchUnsignedPrivacyPolicy,
  fetchPrivacyPolicies,
} from '../api/privacyPolicies.api';

export const privacyPoliciesQueryKeys = createQueryKeys('privacyPolicies', {
  fetchPrivacyPolicies: ({ filters }: FetchPrivacyPoliciesArgs) => ({
    queryFn: () =>
      fetchPrivacyPolicies({
        filters: {
          ...filters,
          offset: (filters?.offset as string) || '1',
          orderBy: filters?.orderBy || 'version',
        },
      }),
    queryKey: [filters],
  }),
  fetchUnsignedPrivacyPolicy: ({ language }: FetchUnsignedPrivacyPolicy) => ({
    queryFn: () =>
      fetchUnsignedPrivacyPolicy({
        language,
      }),
    queryKey: [language],
  }),
});
